<template>
    <div class="Nopay">
        <mt-header title="待支付订单" class="mtheader">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
        <div class="nohistory" v-show="showStyle && noPayList.length==0">
            <img src="../assets/images/his-icon.png" width="283" height="180">
            <p>暂无记录哦！</p>
        </div>
        <div class="history-list" v-show="showStyle && noPayList.length>0">
            <div class="order" v-for="(item,ind) in noPayList" :key='ind'>
                <div class="state-card">
                        <div style="width:70%;text-align:left;">
                        <label>{{item["案件号"]}}</label>
                        </div>
                        <div class="state-text">{{item["当前状态"]}}</div>
                    </div>
                <div class="o-detail">
                    <div v-for="(v,k,i) in item" :key="i" class="detail-cont">
                    <div class="o-d-left">
                            <p v-if="k!='当前状态' && k!='案件号' && k!='案件GUID'">{{k}}</p>
                        
                    </div>
                    <div class="o-d-right">
                            <p v-if="k!='当前状态' && k!='案件号' && k!='案件GUID'">{{v}}</p>
                    </div>
                    </div>
                </div>
                <mt-button class="o-btn" size="normal" @click="toPay(ind)">去支付</mt-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Indicator } from "mint-ui";
export default {
    name:"Nopay",
    data(){
        return{
            showStyle:false,
            noPayList:[]
        }
    },
    created(){
        Indicator.open({spinnerType: 'fading-circle'});
        this.getNoPayList();
    },
    methods:{
        toPay(ind){
            this.$router.push("/Detail.html?caseguid="+this.noPayList[ind]["案件GUID"]);
        },
        getNoPayList(){
            this.$Api.getHistory().then(res=>{
        this.showStyle=true;
        Indicator.close();
        var list=res.data;
            for(var i=0;i<list.length;i++){
                var item = list[i];
                if(item["当前状态"]=="已审批"){
                    var time = item["创建时间"].replace(/T/g, ' ').replace(/.[\d]{3}Z/, ' ');
                    var creattime=time.slice(0,time.indexOf("."))
                    this.noPayList.push({
                        "案件号":item["案件号"],
                        "案件GUID":item["案件GUID"],
                        "姓名":item["申请人姓名"]?item["申请人姓名"]:"待定",
                        "证件类型":item["申请人证件类型"]?item["申请人证件类型"]:"待定",
                        "证件号":item["申请人证件号"]?item["申请人证件号"]:"待定",
                        "手机号码":item["申请人联系电话"]?item["申请人联系电话"]:"待定",
                        "文件类型":item["翻译文件类型"]?item["翻译文件类型"]:"待定",
                        "原件语种":item["翻译件语种"]?item["翻译件语种"]:"待定",
                        "当前状态":item["当前状态"]?item["当前状态"]:"待定",
                        "案件时间":creattime,
                        "缴费金额":item["总价分"]?"￥ "+(Number(item["总价分"])/100).toFixed(2):"待定",
                    })
                 }
            }

    });
        }
    }
}
</script>

<style scoped>
.state-card{
    color: black;font-size: 13px;
    width: auto;
    left: 15px;
    position: absolute;
    right: 0;
    top: 0;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 0.5px solid #84D6AC;
}
.detail-cont{
    display: flex;
    align-items: center;
}
.detail-cont p{margin-top: 0;}
.o-btn{
    width: 100%;
    color: white;
    background-color: #09BB07;
}
.state-text{
    width: 30%;
    border-radius: 0 10px 0 0;
    color: white;
    text-align: center;
    line-height: 40px;
    height: 40px;
    background-color: #84D6AC;
}

.nohistory{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.order{ 
    background-color: white;
    margin-top: 10px;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1);
    padding: 15px;
    position: relative;
    padding-top: 55px;
}
.o-state{display: flex;justify-content: space-between;color: #222222;font-size: 13px;}
.o-d-left{width: 20%;font-size: 13px;color: #666;; text-align: right;}
.o-d-right{width: 75%;font-size: 13px;color: #000;text-align: left;margin-left: 5%;}
.nohistory{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
}
.nohistory p{
color: black;
font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/Nopay.vue